var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import React from 'react';
import styled from 'styled-components';
import { useTranslation } from 'react-i18next';
import { Menu, MenuItem } from '@mui/material';
import { TranslationLanguages } from '../../../constants/translationLanguages';
var Root = styled.span(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  a {\n    text-decoration: underline;\n    cursor: pointer;\n  }\n"], ["\n  a {\n    text-decoration: underline;\n    cursor: pointer;\n  }\n"])));
var TranslateButton = function (_a) {
    var languagePreference = _a.languagePreference, translated = _a.translated, onTranslate = _a.onTranslate;
    var t = useTranslation().t;
    var _b = React.useState(), menuAnchor = _b[0], setMenuAnchor = _b[1];
    var openLanguageChoice = React.useCallback(function (event) {
        setMenuAnchor(event.currentTarget);
    }, []);
    var handleClickTranslate = React.useCallback(function (event) {
        if (languagePreference) {
            onTranslate(languagePreference);
            return;
        }
        openLanguageChoice(event);
    }, [languagePreference, onTranslate, openLanguageChoice]);
    var handleMenuClose = React.useCallback(function () { return setMenuAnchor(undefined); }, []);
    return (React.createElement(Root, null,
        translated ? (React.createElement("a", { role: "button", onClick: openLanguageChoice }, t('pages.offerListForum.changeTranslationLanguage'))) : (React.createElement("a", { role: "button", onClick: handleClickTranslate }, t('pages.offerListForum.translateMessage'))),
        React.createElement(Menu, { anchorEl: menuAnchor, anchorOrigin: { vertical: 'top', horizontal: 'right' }, transformOrigin: { vertical: 'center', horizontal: 'left' }, open: !!menuAnchor, onClose: handleMenuClose }, TranslationLanguages.map(function (language) { return (React.createElement(MenuItem, { key: language, onClick: function () {
                onTranslate(language);
                handleMenuClose();
            } }, t("pages.offerListForum.languages.".concat(language)))); }))));
};
export default TranslateButton;
var templateObject_1;
